import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import get_pager_data from 'nllib/src/pager-helper/get_pager_data';
import to_boolean from 'nllib/src/convert/to_boolean';
import to_string from 'nllib/src/convert/to_string';

export default {
    components: {},
    props: {
        value: {
            // type: Object,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            input: ``,
            selected_entity: null,

            all_entity_list: [],

            panel_select_entity: {
                show: false,
                flag_mouse_over_panel: false,
                tab_list: [],
            },

            panel_filter_entity: {
                show: false,
                flag_mouse_over_panel: false,
                entity_list: [],
                pager_data: {
                    page_index: 1,
                    page_size: 5,
                    page_count: 0,
                    record_count: 0,
                    list: [],
                    list_all: [],
                },
            },

            init_parameter: {
                entity_define: {
                    property_name_for_code: ``,
                    property_name_for_name: ``,
                    property_name_for_pin_yin: ``,
                    property_name_for_jian_pin: ``,
                    property_name_for_first_letter: ``,
                },

                get_data_source: null,

                panel_select_entity: {
                    get_tab_list: null,
                },

                panel_filter_entity: {
                    title: `简码/汉字`,
                    is_show_code: true,
                },

                //panel使用场景
                //000:panel_select_entity和panel_filter_entity都使用，例如train-city-selector
                //100:panel_select_entity不使用，只使用panel_filter_entity，例如domestic-ticket-airline-selector
                panel_use_situation: `000`,
            },

        };
    },
    watch: {
        value(pNewValue, pOldValue) {
            const __this = this;
            const property_name_for_code = __this.init_parameter.entity_define.property_name_for_code;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;

            if (!pNewValue) {
                __this.selected_entity = null;
                return;
            }

            let code;
            if (_.isNumber(pNewValue)) {
                code = pNewValue;
            } else if (_.isString(pNewValue)) {
                code = pNewValue;
            } else if (_.isObject(pNewValue)) {
                code = pNewValue[property_name_for_code];
            } else {
                const msg = `frontend/common-project/component/base-entity-selector::watch::value parameter error, code=001`;
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }

            const query = _.chain(__this.all_entity_list)
                .find(function (m) {
                    let x = ``;
                    if (m[property_name_for_code]) {
                        x = m[property_name_for_code].toString();
                    }
                    let y = ``;
                    if (code) {
                        y = code.toString();
                    }
                    return x === y;
                })
                .value()
            ;
            if (!query) {
                __this.selected_entity = null;
                return;
            }
            __this.selected_entity = query;
        },
        selected_entity(pNewValue, pOldValue) {
            const __this = this;
            const property_name_for_code = __this.init_parameter.entity_define.property_name_for_code;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;

            let name;
            if (pNewValue) {
                name = pNewValue[property_name_for_name];
            } else {
                name = ``;
            }
            __this.input = name;
            __this.$emit('input', pNewValue);
        },
        input(pNewValue, pOldValue) {
            const __this = this;
        },
    },
    methods: {
        __init_data() {
            const __this = this;
            const property_name_for_code = __this.init_parameter.entity_define.property_name_for_code;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const get_data_source = __this.init_parameter.get_data_source;

            return Q.when()
                .then(function () {
                    return get_data_source();
                })
                .then(function (data) {
                    if (!data) {
                        const msg = '__init_data parameter error, code=001';
                        console.error(msg);
                        console.trace();
                        return Q.reject({msg: msg});
                    }

                    const all_entity_list = data.all_entity_list;
                    if (!_.isArray(all_entity_list)) {
                        const msg = '__init_data parameter error, code=002';
                        console.error(msg);
                        console.trace();
                        return Q.reject({msg: msg});
                    }

                    __this.all_entity_list = all_entity_list;

                    __this.__panel_select_entity_init_data();
                    __this.__panel_filter_entity_init_data();

                    // const all_entity_list = __this.all_entity_list;
                    const v = __this.value;
                    if (!v) return;
                    const code = v[property_name_for_code];
                    const query = _.chain(all_entity_list)
                        .find(function (m) {
                            const __code = m[property_name_for_code];
                            return __code === code;
                        })
                        .value()
                    ;
                    if (!query) return;
                    __this.selected_entity = query;
                })
                .catch(function (ex) {
                    console.error(ex);
                    if (ex) {
                        if (ex.stack) {
                            console.error(ex.stack);
                        }
                    }
                    return Q.reject(ex);
                })
                ;
        },

        //<editor-fold desc="input">
        __input_click_event_handler() {
            const __this = this;

            const panel_use_situation = __this.init_parameter.panel_use_situation;
            if (panel_use_situation === `000`) {
                __this.panel_filter_entity.show = false;
                __this.panel_select_entity.show = true;
            }

            if (panel_use_situation === `100`) {
                __this.panel_filter_entity.show = true;
                __this.panel_select_entity.show = false;
            }

        },

        __input_blur_event_handler() {
            const __this = this;
            const property_name_for_code = __this.init_parameter.entity_define.property_name_for_code;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;

            if (!__this.panel_select_entity.flag_mouse_over_panel) {
                __this.panel_select_entity.show = false;
            }

            if (!__this.panel_filter_entity.flag_mouse_over_panel) {
                __this.panel_filter_entity.show = false;

                let selected_entity_name;
                if (__this.selected_entity) {
                    selected_entity_name = __this.selected_entity[property_name_for_name];
                } else {
                    selected_entity_name = ``;
                }
                if (selected_entity_name !== __this.input) {
                    __this.selected_entity = null;
                    __this.input = ``;
                }
            }

            //TODO:注释了这几行，不知道会不会有什么问题，待观察
            // __this.__panel_filter_entity_init_entity_list();
            // __this.__panel_filter_entity_init_pager_data({
            //   page_index: 1,
            // });

        },

        __input_focus_event_handler() {
            const __this = this;
        },

        __input_keyup_event_handler($event) {
            const __this = this;
            const code = $event.code;
            const __input = (__this.input || ``).toLowerCase();
            // console.log($event);
            // console.log(`__input=${__input}`);

            __this.panel_select_entity.show = false;
            __this.panel_filter_entity.show = true;

            if (!_.contains([`ArrowDown`, `ArrowUp`, `ArrowLeft`, `ArrowRight`, `Enter`], code)) {
                //不是特殊按键，进行初始化数据源
                //特殊按键：向下箭头、向上箭头，回车
                __this.__panel_filter_entity_init_entity_list();
                __this.__panel_filter_entity_init_pager_data({
                    page_index: 1,
                });
            }

            //向下箭头
            if (code === `ArrowDown`) {
                const index_entity_active_001 = _.chain(__this.panel_filter_entity.pager_data.list)
                    .findIndex(function (m) {
                        return m.active;
                    })
                    .value()
                ;
                let index_entity_active_002;
                if (index_entity_active_001 === -1) {
                    //当前找不到active=true时
                    //下一个为当前页的第一个
                    //不需要重置上一个的active
                    index_entity_active_002 = 0;
                } else if (index_entity_active_001 === (__this.panel_filter_entity.pager_data.list.length - 1)) {
                    //当前为一页的最后一个
                    if (__this.panel_filter_entity.pager_data.page_index === __this.panel_filter_entity.pager_data.page_count) {
                        //当前为最后一页，进行翻页，即获取分页数据源
                        //下一个为第一页的第一个
                        //不需要重置上一个的active
                        const new_page_index = 1;
                        __this.__panel_filter_entity_init_pager_data({
                            page_index: new_page_index,
                        });
                        index_entity_active_002 = 0;
                    } else {
                        //当前不是最后一页，进行翻页，即获取分页数据源
                        //下一个为下一页的第一个
                        //不需要重置上一个的active
                        const new_page_index = __this.panel_filter_entity.pager_data.page_index + 1;
                        __this.__panel_filter_entity_init_pager_data({
                            page_index: new_page_index,
                        });
                        index_entity_active_002 = 0;
                    }
                } else {
                    //需要重置上一个的active
                    index_entity_active_002 = index_entity_active_001 + 1;
                }

                _.each(__this.panel_filter_entity.pager_data.list_all, function (m) {
                    m.active = false;
                });
                __this.panel_filter_entity.pager_data.list[index_entity_active_002].active = true;
                __this.selected_entity = __this.panel_filter_entity.pager_data.list[index_entity_active_002];
            }

            //向上箭头
            if (code === `ArrowUp`) {
                const index_entity_active_001 = _.chain(__this.panel_filter_entity.pager_data.list)
                    .findIndex(function (m) {
                        return m.active;
                    })
                    .value()
                ;
                let index_entity_active_002;
                if (index_entity_active_001 === -1) {
                    //当前找不到active=true时
                    //下一个为当前页的最后一个
                    //不需要重置上一个的active
                    index_entity_active_002 = __this.panel_filter_entity.pager_data.list.length - 1;
                } else if (index_entity_active_001 === 0) {
                    //当前为一页的第一个
                    if (__this.panel_filter_entity.pager_data.page_index === 1) {
                        //当前为第一页，进行翻页，即获取分页数据源
                        //下一个为最后一页的最后一个
                        //不需要重置上一个的active
                        const new_page_index = __this.panel_filter_entity.pager_data.page_count;
                        __this.__panel_filter_entity_init_pager_data({
                            page_index: new_page_index,
                        });
                        index_entity_active_002 = __this.panel_filter_entity.pager_data.list.length - 1;
                    } else {
                        //当前不是第一页，进行翻页，即获取分页数据源
                        //下一个为上一页的最后一个
                        //不需要重置上一个的active
                        const new_page_index = __this.panel_filter_entity.pager_data.page_index - 1;
                        __this.__panel_filter_entity_init_pager_data({
                            page_index: new_page_index,
                        });
                        index_entity_active_002 = __this.panel_filter_entity.pager_data.list.length - 1;
                    }
                } else {
                    //需要重置上一个的active
                    index_entity_active_002 = index_entity_active_001 - 1;
                }

                _.each(__this.panel_filter_entity.pager_data.list_all, function (m) {
                    m.active = false;
                });
                __this.panel_filter_entity.pager_data.list[index_entity_active_002].active = true;
                __this.selected_entity = __this.panel_filter_entity.pager_data.list[index_entity_active_002];
            }

            //回车
            if (code === `Enter`) {
                const entity_active = _.chain(__this.panel_filter_entity.pager_data.list)
                    .find(function (m) {
                        return m.active;
                    })
                    .value()
                ;
                if (entity_active) {
                    __this.__entity_click_event_handler(entity_active);
                }
            }
        },

        //</editor-fold>

        //<editor-fold desc="panel_select_entity">

        __panel_select_entity_init_data() {
            const __this = this;

            const all_entity_list = __this.all_entity_list;
            const init_parameter = __this.init_parameter;

            const get_tab_list = __this.init_parameter.panel_select_entity.get_tab_list;

            Q.when()
                .then(function () {
                    return get_tab_list({
                        all_entity_list,
                        init_parameter,
                    });
                })
                .then(function (data) {
                    if (!data) {
                        const msg = '__panel_select_entity_init_data parameter error, code=001';
                        console.error(msg);
                        console.trace();
                        return Q.reject({msg: msg});
                    }

                    const tab_list = data.tab_list;
                    if (!_.isArray(tab_list)) {
                        const msg = '__panel_select_entity_init_data parameter error, code=002';
                        console.error(msg);
                        console.trace();
                        return Q.reject({msg: msg});
                    }

                    __this.panel_select_entity.tab_list = tab_list;

                    if (__this.panel_select_entity.tab_list.length > 0) {
                        __this.panel_select_entity.tab_list[0].active = true;
                    }
                })
                .catch(function (ex) {
                    console.error(ex);
                    console.trace();
                    if (ex) {
                        if (ex.stack) {
                            console.error(ex.stack);
                        }
                    }
                    return Q.reject(ex);
                })
            ;

        },

        __panel_select_entity_click_event_handler() {
            const __this = this;
            // console.log(`__panel_select_entity_click_event_handler`);
            __this.$refs.aInput.focus();
        },

        __panel_select_entity_btn_close_click_event_handler() {
            const __this = this;
            __this.panel_select_entity.show = false;
        },

        __panel_select_entity_tab_title_click_event_handler(pTabEntity) {
            const __this = this;
            const tab_list = __this.panel_select_entity.tab_list;

            _.each(tab_list, function (m) {
                m.active = false;
            });
            pTabEntity.active = true;
        },

        __panel_select_entity_mouseenter_event_handler() {
            const __this = this;
            // console.log(`__panel_select_entity_mouseenter_event_handler`);
            __this.panel_select_entity.flag_mouse_over_panel = true;
        },

        __panel_select_entity_mouseleave_event_handler() {
            const __this = this;
            // console.log(`__panel_select_entity_mouseleave_event_handler`);
            __this.panel_select_entity.flag_mouse_over_panel = false;
        },

        //</editor-fold>

        //<editor-fold desc="panel_filter_entity">

        __panel_filter_entity_init_entity_list() {
            const __this = this;
            const property_name_for_code = __this.init_parameter.entity_define.property_name_for_code;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const property_name_for_pin_yin = __this.init_parameter.entity_define.property_name_for_pin_yin;
            const property_name_for_jian_pin = __this.init_parameter.entity_define.property_name_for_jian_pin;

            const __input = (__this.input || ``).toLowerCase();
            __this.panel_filter_entity.entity_list = _.chain(__this.all_entity_list)
                .filter(function (m) {
                    const code = to_string(m[property_name_for_code]).toLowerCase();
                    const name = to_string(m[property_name_for_name]).toLowerCase();
                    const pin_yin = to_string(m[property_name_for_pin_yin]).toLowerCase();
                    const jian_pin = to_string(m[property_name_for_jian_pin]).toLowerCase();

                    let flag = false;
                    flag = flag || (code.indexOf(__input) > -1);
                    flag = flag || (name.indexOf(__input) > -1);
                    flag = flag || (pin_yin.indexOf(__input) > -1);
                    flag = flag || (jian_pin.indexOf(__input) > -1);
                    return flag;
                })
                .map(function (m) {
                    //由于改变了数组的费用，必须进行深拷贝，否则vue的双向绑定无效！
                    const o = extend(true, {}, m);
                    o.active = false;
                    return o;
                })
                .value()
            ;
        },

        __panel_filter_entity_init_pager_data(pParameter) {
            const __this = this;
            if (!pParameter) pParameter = {};
            const page_index = pParameter.page_index || __this.panel_filter_entity.pager_data.page_index;
            const page_size = pParameter.page_size || __this.panel_filter_entity.pager_data.page_size;

            __this.panel_filter_entity.pager_data = get_pager_data({
                list_all: __this.panel_filter_entity.entity_list,
                page_index: page_index,
                page_size: page_size,
            });
            // console.log(__this.panel_filter_entity.pager_data);
        },

        __panel_filter_entity_init_data() {
            const __this = this;

            const all_entity_list = __this.all_entity_list;

            __this.panel_filter_entity.entity_list = _.chain(all_entity_list)
            // .filter(function (m, i) {
            //   return i < 10;
            // })
                .map(function (m) {
                    const o = extend(true, {}, m);
                    o.active = false;
                    return o;
                })
                .value()
            ;
            __this.__panel_filter_entity_init_pager_data();
        },

        __panel_filter_entity_click_event_handler() {
            const __this = this;
            // console.log(`__panel_filter_entity_click_event_handler`);
            __this.$refs.aInput.focus();
        },

        __panel_filter_entity_entity_mouseover_event_handler(pEntity, e) {
            const __this = this;
            // console.log(e);
            _.each(__this.panel_filter_entity.entity_list, function (m) {
                m.active = false;
            });
            pEntity.active = true;
            __this.selected_entity = pEntity;

            __this.$refs.aInput.focus();
        },

        __panel_filter_entity_el_pagination_current_change_event_handler(pPageIndex) {
            const __this = this;
            // console.log(`__panel_filter_entity_el_pagination_current_change_event_handler`);
            // console.log(`pPageIndex=${pPageIndex}`);
            __this.__panel_filter_entity_init_pager_data({
                page_index: pPageIndex,
            });
            __this.$refs.aInput.focus();
        },

        __panel_filter_entity_mouseenter_event_handler() {
            const __this = this;
            // console.log(`__panel_filter_entity_mouseenter_event_handler`);
            __this.panel_filter_entity.flag_mouse_over_panel = true;
        },

        __panel_filter_entity_mouseleave_event_handler() {
            const __this = this;
            // console.log(`__panel_filter_entity_mouseleave_event_handler`);
            __this.panel_filter_entity.flag_mouse_over_panel = false;
        },

        //</editor-fold>

        __entity_click_event_handler(pEntity, e) {
            const __this = this;
            // console.log(`__entity_click_event_handler`);

            __this.selected_entity = pEntity;
            __this.panel_select_entity.show = false;
            __this.panel_filter_entity.show = false;

            if (e) {
                if (_.isFunction(e.stopPropagation)) {
                    e.stopPropagation();
                }
            }

        },

        init(pParameter) {
            if (!pParameter) pParameter = {};

            const defaultParameter = {};
            defaultParameter.entity_define = {};
            defaultParameter.entity_define.property_name_for_code = ``;
            defaultParameter.entity_define.property_name_for_name = ``;
            defaultParameter.entity_define.property_name_for_pin_yin = ``;
            defaultParameter.entity_define.property_name_for_jian_pin = ``;
            defaultParameter.entity_define.property_name_for_first_letter = ``;

            defaultParameter.get_data_source = null;

            defaultParameter.panel_select_entity = {};
            defaultParameter.panel_select_entity.get_tab_list = null;

            defaultParameter.panel_select_entity = {};
            defaultParameter.panel_select_entity.get_tab_list = null;

            defaultParameter.panel_filter_entity = {};
            defaultParameter.panel_filter_entity.title = `简码/汉字`;

            defaultParameter.panel_use_situation = `000`;

            const parameter = extend({}, defaultParameter, pParameter);

            //<editor-fold desc="code=10x">
            if (!_.isFunction(parameter.get_data_source)) {
                const msg = 'init parameter error, code=001';
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }

            if (!_.isFunction(parameter.panel_select_entity.get_tab_list)) {
                const msg = 'init parameter error, code=002';
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }
            //</editor-fold>

            //<editor-fold desc="code=11x">
            if (!parameter.entity_define.property_name_for_code) {
                const msg = 'init parameter error, code=101';
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }

            if (!parameter.entity_define.property_name_for_name) {
                const msg = 'init parameter error, code=101';
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }

            if (!parameter.entity_define.property_name_for_pin_yin) {
                const msg = 'init parameter error, code=101';
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }

            if (!parameter.entity_define.property_name_for_jian_pin) {
                const msg = 'init parameter error, code=101';
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }

            if (!parameter.entity_define.property_name_for_first_letter) {
                const msg = 'init parameter error, code=101';
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }
            //</editor-fold>

            const __this = this;

            __this.init_parameter.entity_define.property_name_for_code = parameter.entity_define.property_name_for_code;
            __this.init_parameter.entity_define.property_name_for_name = parameter.entity_define.property_name_for_name;
            __this.init_parameter.entity_define.property_name_for_pin_yin = parameter.entity_define.property_name_for_pin_yin;
            __this.init_parameter.entity_define.property_name_for_jian_pin = parameter.entity_define.property_name_for_jian_pin;
            __this.init_parameter.entity_define.property_name_for_first_letter = parameter.entity_define.property_name_for_first_letter;

            __this.init_parameter.get_data_source = parameter.get_data_source;

            __this.init_parameter.panel_select_entity.get_tab_list = parameter.panel_select_entity.get_tab_list;

            __this.init_parameter.panel_filter_entity.title = parameter.panel_filter_entity.title;
            __this.init_parameter.panel_filter_entity.is_show_code = to_boolean(parameter.panel_filter_entity.is_show_code, true);

            __this.init_parameter.panel_use_situation = parameter.panel_use_situation;

            __this.__init_data();
        },
    },
    created() {
    },
    mounted() {
    },
}
